const BASE = '/master-data';

async function fetchJson(name) {
  const res = await fetch(`${BASE}/${name}`);
  if (!res.ok) return [];
  return res.json();
}

function normalize(arr) {
  return (arr || []).map(i => ({
    id: i.id,
    label: i.label || i.value || i.name || String(i.id),
    value: i.value || i.label || i.name || String(i.id),
    ...i,
  }));
}

export async function loadMasterData() {
  const [religions, castes, languages] = await Promise.all([
    fetchJson('religions.json'),
    fetchJson('castes.json'),
    fetchJson('languages.json'),
  ]);
  return {
    religions: normalize(religions),
    castes: normalize(castes),
    languages: normalize(languages),
  };
}

export default { loadMasterData };
